import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Dag',
    [filter_week]: 'Uge',
    [filter_month]: 'Måned',
    null: 'I alt',
  },
};
